import { render, staticRenderFns } from "./role-add.vue?vue&type=template&id=5201b802&scoped=true&"
import script from "./role-add.vue?vue&type=script&lang=js&"
export * from "./role-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=5201b802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201b802",
  null
  
)

component.options.__file = "role-add.vue"
export default component.exports